'use client'

import { useEffect, useState } from 'react'
import { BiAlarm } from "react-icons/bi"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import { ServiceCoursesProvider } from 'api/ServiceCoursesProvider'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from 'contexts/LanguageContext'
import 'swiper/css'
import 'swiper/css/navigation'
import ISessionFormation from 'models/ISessionFormation'

export default function FeaturedCourses() {
  const {lang, res} = useLanguage();
  const navigate = useNavigate();
  const [courses, setCourses] = useState([])
  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    setIsMobile(window.innerWidth < 640)

    const getFeaturedCourses = async function() {
      const courses = await ServiceCoursesProvider.provider.getFeaturedCourses()
      setCourses(courses)
    }
    // if no session has been selected
    getFeaturedCourses()
  }, [])

  useEffect(() => {
    const resizeHandler = () => {
        setIsMobile(window.innerWidth < 640)
    }
    // Add event listener
    window.addEventListener("resize", resizeHandler)
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", resizeHandler)
  }, [])

  const displayHour = (course: ISessionFormation) => {
    if (!course?.dateSession) {
      return null;
    }

    const dateSession = new Date(course.dateSession);
    // Format hours and minutes from the dateSession
    const hours = dateSession.getHours().toString().padStart(2, '0');
    const minutes = dateSession.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
  }

  return (
    <>
      <h1 className="h1 mb-4" data-aos="fade-up">{res["Formations en vedette"]}</h1>
      {/* <p className="text-xl text-gray-400 mb-8" data-aos="fade-up" data-aos-delay="200">Our landing page template works on all devices, so you only have to set it up once, and get beautiful results forever.
      </p> */}
      {(courses) ? (
        <Swiper
            spaceBetween={0}
            navigation={true}
            slidesPerView={(isMobile) ? 1 : 3}
            modules={[Navigation]}
            // onSlideChange={(slide) => onSlideChange(slide)}
            // onSwiper={(swiper) => console.log("onSwiper: ", swiper)}
            className={(isMobile) ? "featured-navigation" : "featured-navigation desktop"}
        >
        {courses.map((course: any, i) => (
          <SwiperSlide
              key={"featuredCourse"+i}
              id={"featuredCourse"+i}
              onClick={() => navigate(`/${lang}/courses/${course.id}`)}
              className="link"
          >
            <div className={"pl-5 pr-5"}>
              <div style={{position: "relative"}}>
                <img 
                  src={(course.imageUrl) ? course.imageUrl : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="} 
                  style={{height: (!course.imageUrl) ? "190px" : undefined}} 
                  alt={(course.titreLong) ? course.titreLong[course.langue] : "--"} 
                />
                <div className="c-post-date-wpr">
                  <div className="c-post-cat">
                    <span>{course.categoriePrincipale?.titre[lang]}</span>
                  </div>
                  <div className="c-post-cat-date-wpr" style={{fontSize: "12px", background: (!course.imageUrl) ? "#333333" : undefined}}>
                    <span>{new Date((course?.date) ? course?.date : course?.dateSession).toLocaleString(lang + '-CA', {month: 'short', day: 'numeric'})}
                      &nbsp; {displayHour(course)}
                    </span>
                  </div>
                </div>
              </div>
              <div className="c-post-list-item-head">
                <h3>{(course.titreLong) ? course.titreLong[course.langue] : "--"}</h3>
                <svg id="Component_5_46" data-name="Component 5 - 46" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="22" height="26.466" viewBox="0 0 22 26.466">
                  <defs>
                    <clipPath id="clip-path">
                      <rect id="Rectangle_1913" data-name="Rectangle 1913" width="11.321" height="12.933" fill="none"/>
                    </clipPath>
                  </defs>
                  <path id="Polygon_31" data-name="Polygon 31" d="M13,0,26,22H0Z" transform="translate(22) rotate(90)" fill="#ff5000"/>
                  <text id="i" transform="translate(9 18)" fontSize="12" fontFamily="SegoeUIBlack, Segoe UI"><tspan x="-3.697" y="0">i</tspan></text>
                  <g id="Group_1064" data-name="Group 1064" transform="translate(7.5 13.534)">
                    <g id="Group_1063" data-name="Group 1063" clipPath="url(#clip-path)">
                      <path id="Path_6374" data-name="Path 6374" d="M51.124,53.764a.123.123,0,0,0,0,.027l.161.652a.122.122,0,0,1,0-.026s0-.005,0-.008a.117.117,0,0,1,0-.016.121.121,0,0,1,.006-.021l0-.008.006-.01.008-.013.007-.008.01-.011.012-.01.01-.007.017-.009.009,0a.138.138,0,0,1,.028-.007.134.134,0,0,1,.076.012l9.149,4.267a.124.124,0,0,1,.06.057.121.121,0,0,1,.009.025l-.161-.652a.122.122,0,0,0-.069-.082l-9.149-4.267a.133.133,0,0,0-.1,0l-.009,0-.017.009h0l-.007.006-.012.01,0,0-.007.009-.007.008,0,0-.006.011-.005.01v0s0,0,0,.006a.119.119,0,0,0-.006.021v0s0,.008,0,.012,0,.005,0,.008" transform="translate(-50.326 -52.794)"/>
                      <path id="Path_6375" data-name="Path 6375" d="M536.735,326.878c0-.009,0-.019,0-.028s0-.012,0-.018,0-.02,0-.03,0-.01,0-.015-.005-.029-.009-.044h0l-.161-.652c0,.015.006.03.009.044s0,.01,0,.015,0,.02,0,.03,0,.012,0,.017,0,.019,0,.028,0,.012,0,.018,0,.018,0,.027l0,.016a.5.5,0,0,1-.012.058l0,.008a.5.5,0,0,1-.019.052l0,.01c-.005.011-.011.022-.017.033l0,.009c-.008.014-.016.027-.025.04l-.01.013-.018.023-.013.014-.019.021-.013.012-.025.022-.016.012-.027.019-.016.011a.6.6,0,0,1-.054.03l-.043.021-2.434,1.218-.008,0-.013.01h0v0l-.007.009-.006.01v0h0a.074.074,0,0,0-.006.02s0,0,0,0,0,0,0,0a.072.072,0,0,0,0,.023l.161.652a.076.076,0,0,1,0-.023v0a.077.077,0,0,1,.006-.023v0a.078.078,0,0,1,.013-.019v0a.083.083,0,0,1,.022-.016l2.434-1.218.043-.021a.589.589,0,0,0,.054-.03l.006,0,.01-.007.027-.019.016-.012.025-.022.009-.008,0,0,.019-.021.013-.014.018-.023.009-.011v0c.009-.013.018-.027.025-.04l0-.009c.006-.011.011-.022.016-.033l0,0,0-.007a.5.5,0,0,0,.019-.052l0-.008a.507.507,0,0,0,.012-.058v-.006s0-.007,0-.01,0-.018,0-.027,0-.012,0-.018" transform="translate(-525.414 -320.997)"/>
                      <path id="Path_6376" data-name="Path 6376" d="M478.173,445.9a.285.285,0,0,0-.063-.12L475.3,442.56a.23.23,0,0,1-.05-.1l.161.652a.229.229,0,0,0,.05.1l2.813,3.221a.3.3,0,0,1,.022.028.283.283,0,0,1,.041.092h0Z" transform="translate(-467.823 -435.552)"/>
                      <path id="Path_6377" data-name="Path 6377" d="M12.223,51.6s0-.01,0-.015,0-.025,0-.037l0-.015c0-.017-.006-.033-.01-.05l-.161-.652c0,.016.007.033.01.05l0,.015q0,.019,0,.037s0,.01,0,.015,0,.033,0,.05h0c0,.016,0,.033,0,.049l0,.02,0,.019,0,.022,0,.019-.006.021-.006.018-.008.021-.007.018-.005.012q-.009.02-.019.039l-.007.013c-.009.016-.019.031-.029.046h0c-.01.014-.021.028-.032.041l-.011.012-.027.028-.012.012c-.014.013-.028.026-.043.038l-1.5,1.213c-.017.013-.034.025-.051.037l-.012.008c-.018.012-.037.022-.056.032l-.008,0-.055.023-.01,0c-.02.007-.04.013-.06.018l-.013,0c-.021,0-.042.009-.063.012a.639.639,0,0,1-.568-.207L6.786,49.576a.079.079,0,0,0-.071-.026l-.016,0,0,0-.01.005h0l0,0-.007.005,0,0-.007.008-1.674,2.1-.027.034a.566.566,0,0,1-.045.05l-.019.017-.022.019-.021.016-.023.016-.02.012-.031.018-.02.01-.033.014-.02.008-.037.011-.017,0-.055.01a.524.524,0,0,1-.586-.367L.979,41.313l-.033-.1q-.006-.018-.01-.036h0l.161.652q0,.018.01.036l.033.1L4.174,52.2a.524.524,0,0,0,.586.367l.055-.01.017,0,.037-.011.02-.008.033-.014.02-.01.031-.018.012-.007.007-.005.023-.016.021-.016.022-.019.014-.012,0-.005a.561.561,0,0,0,.045-.05l.027-.034,1.674-2.1.009-.01.007-.005.006,0,.01-.005,0,0,.016,0a.079.079,0,0,1,.071.026l2.642,3.024a.639.639,0,0,0,.568.207c.021,0,.042-.007.063-.012l.013,0c.02-.005.04-.011.06-.018l.01,0,.055-.023.008,0c.019-.01.038-.02.056-.032l.006,0,.006,0c.017-.012.035-.024.051-.037l1.5-1.213c.015-.012.029-.025.043-.038l0,0,.007-.007.027-.029.01-.012c.011-.013.022-.027.032-.041h0c.011-.015.02-.031.029-.046l.007-.013q.01-.019.019-.039l0-.008,0,0,.007-.018.008-.021.006-.018.006-.021,0-.019,0-.022,0-.019,0-.014s0,0,0-.006,0-.032,0-.049h0c0-.017,0-.033,0-.05" transform="translate(-0.92 -40.532)"/>
                      <path id="Path_6378" data-name="Path 6378" d="M8.382,6.919,10.817,5.7l.043-.021a.507.507,0,0,0-.006-.929L.9.107.8.058A.545.545,0,0,0,.478,0,.53.53,0,0,0,.025.68l.033.1L3.092,11.018a.524.524,0,0,0,.586.367.549.549,0,0,0,.361-.207l.027-.034,1.674-2.1a.082.082,0,0,1,.054-.03.079.079,0,0,1,.071.026l2.642,3.024a.639.639,0,0,0,.568.207.665.665,0,0,0,.328-.141l1.5-1.213A.6.6,0,0,0,11,10.06L8.356,7.036a.075.075,0,0,1,.026-.117m-.908.089,2.813,3.221a.292.292,0,0,1-.044.423l-1,.806a.327.327,0,0,1-.161.069.315.315,0,0,1-.28-.1L5.988,8.2a.251.251,0,0,0-.224-.081.259.259,0,0,0-.168.095L3.822,10.438a.136.136,0,0,1-.089.05.13.13,0,0,1-.144-.089L.8,1A.131.131,0,0,1,.916.839.135.135,0,0,1,.992.851l9.149,4.267a.125.125,0,0,1,0,.227L7.967,6.431l-.412.209a.237.237,0,0,0-.081.368" transform="translate(0 0)"/>
                      <path id="Path_6379" data-name="Path 6379" d="M57.864,59.432l.412-.209,2.172-1.087a.125.125,0,0,0,0-.227L51.3,53.643a.135.135,0,0,0-.076-.012.131.131,0,0,0-.113.164l2.785,9.4a.13.13,0,0,0,.144.089.136.136,0,0,0,.089-.05L55.9,61.009a.259.259,0,0,1,.168-.095A.251.251,0,0,1,56.3,61l2.815,3.223a.315.315,0,0,0,.28.1.327.327,0,0,0,.161-.069l1-.806a.292.292,0,0,0,.044-.423L57.783,59.8a.237.237,0,0,1,.081-.368" transform="translate(-50.308 -52.793)" fill="#fff"/>
                    </g>
                  </g>
                </svg>
              </div>
              <div className="c-formar-wpr">
                <span>{res["Formateur"]}</span>
                <ol>
                  <li>{course.formateur}</li>
                </ol>
                <div className="c-time" style={{flexGrow: 1, justifyContent: "end"}}>
                  <BiAlarm /> &nbsp;
                  <span style={{margin: 0}}>{course.duree}</span>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
        </Swiper>
      ) : (
        <h1 style={{color: "#212529", fontSize: "2.5rem"}}>{res["Aucune formation à afficher"]}</h1>
      )}
    </>
  )
}
